import React from 'react';
import { PostOrPage } from '@tryghost/content-api';
import { HomePageSection } from 'src/components/HomePage/HomePageSection';
import { DateUtils } from 'src/utils';
import { LatestReleaseCard } from 'src/components/HomePage/LatestReleaseSection/LatestReleaseCard';

interface LatestReleaseSectionProps {
  latestReleasePost: PostOrPage | null;
}
export const LatestReleaseSection: React.FC<LatestReleaseSectionProps> = ({
  latestReleasePost,
}) => {
  const latestReleaseAt = React.useMemo(() => {
    if (!latestReleasePost?.published_at) return '';
    const releaseDate = new Date(latestReleasePost?.published_at);

    const releasePeriodInDays = DateUtils.getDiffFromDate(releaseDate, 'days');
    const releasePeriodInHours = DateUtils.getDiffFromDate(
      releaseDate,
      'hours',
    );
    const releasePeriodInMinutes = DateUtils.getDiffFromDate(
      releaseDate,
      'minutes',
    );

    if (releasePeriodInDays >= 1) {
      return `Last release ${releasePeriodInDays} day${
        releasePeriodInDays > 1 ? 's' : ''
      } ago `;
    }

    if (releasePeriodInHours >= 1) {
      return `Last release ${releasePeriodInHours} hour${
        releasePeriodInHours > 1 ? 's' : ''
      } ago`;
    }

    return `Last release ${releasePeriodInMinutes} minute${
      releasePeriodInMinutes > 1 ? 's' : ''
    } ago`;
  }, [latestReleasePost]);

  if (!latestReleasePost) return null;
  return (
    <HomePageSection title="Latest release" subTitle={latestReleaseAt}>
      <LatestReleaseCard latestReleasePost={latestReleasePost} />
    </HomePageSection>
  );
};
